import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'auth',

  can: {
    route() {
      return this.child && this.isKitchenTeam();
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/KitchenPerimeter.js